/**
 * Returns true when the access-token's `exp` (Unix seconds) is in the past.
 *
 * Used by the root layout to detect a stale localStorage session at boot —
 * see SE-5107. Without this check the gate trusts any non-null `auth.data`,
 * so an expired token leaves the app silently broken (no queries fire, no
 * `/login` redirect, no proactive refresh because the per-request
 * `ensureFreshToken` link never runs).
 *
 * `exp` may legitimately be `null` or `undefined` during the brief window
 * between boot and first `initializeAuthData` resolution — in that case we
 * return `false` so the existing `isAwaitingAuthResults` gating handles it.
 * @param exp - Token expiration timestamp (seconds since Unix epoch)
 * @returns True if exp is a finite number and is strictly less than now
 * @module app/(root)/utils/isAccessTokenExpired
 */
const isAccessTokenExpired = (exp: number | null | undefined): boolean => {
  if (typeof exp !== "number" || !Number.isFinite(exp)) return false;
  return exp < Math.floor(Date.now() / 1000);
};

export default isAccessTokenExpired;
